import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getPrompts, savePrompt as savePromptAPI, deletePrompt } from '../api';
import { savePrompts, addPrompt, removePrompt, setPromptsLoading } from '../../../redux/reducers';

export const usePromptManagement = (
  currProject: string | null,
  roleId: number | null,
  showSnackbar: (options: { message: string; severity: string }) => void
) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const loadPrompts = async () => {
      if (currProject && roleId) {
        try {
          dispatch(setPromptsLoading(true));
          const promptsData = await getPrompts(currProject, roleId);
          dispatch(savePrompts(promptsData));
        } catch (error) {
          console.error('Failed to load prompts:', error);
          showSnackbar({ message: 'Ошибка загрузки промптов', severity: 'error' });
        } finally {
          dispatch(setPromptsLoading(false));
        }
      }
    };
    loadPrompts();
  }, [currProject, roleId, dispatch, showSnackbar]);

  const onSavePrompt = async (content: string) => {
    if (!currProject || !roleId) {
      showSnackbar({ message: 'Не выбран проект или роль', severity: 'error' });
      return;
    }
    try {
      dispatch(setPromptsLoading(true));
      const newPrompt = await savePromptAPI(currProject, roleId, content);
      dispatch(addPrompt(newPrompt));
      showSnackbar({ message: 'Промпт сохранен', severity: 'success' });
    } catch (error) {
      console.error('Failed to save prompt:', error);
      showSnackbar({ message: 'Ошибка сохранения промпта', severity: 'error' });
    } finally {
      dispatch(setPromptsLoading(false));
    }
  };

  const onDeletePrompt = async (promptId: number) => {
    try {
      dispatch(setPromptsLoading(true));
      await deletePrompt(promptId);
      dispatch(removePrompt(promptId));
      showSnackbar({ message: 'Промпт удален', severity: 'success' });
    } catch (error) {
      console.error('Failed to delete prompt:', error);
      showSnackbar({ message: 'Ошибка удаления промпта', severity: 'error' });
    } finally {
      dispatch(setPromptsLoading(false));
    }
  };

  return { onSavePrompt, onDeletePrompt };
};
